import { useEffect } from "react";
import { ChatMessage } from "@/entities/messaging/types";
import DreamerButton, { DreamerState } from "./DreamerButton";
import { useTranslation } from "react-i18next";
import { useNotificationManager } from "@/hooks/useNotificationManager";

interface QueuedDreamerButtonProps {
  title: string;
  state: DreamerState;
  animatedHighlight: boolean;
  notifications?: ChatMessage[];
  notifyTimeout?: number;
}

const QueuedDreamerButton: React.FC<QueuedDreamerButtonProps> = ({
  notifications = [],
  state: externalState,
  ...props
}) => {
  const { t } = useTranslation();
  const { activeNotifications, notificationCount, currentState, syncData } =
    useNotificationManager({
      notifications,
      externalState,
      channelName: "notifications.dreamerbutton.dreamhub"
    });

  useEffect(() => {
    document.title =
      syncData.count > 0
        ? `${t("dreamhub")} (${syncData.count})`
        : t("dreamhub");
  }, [syncData.count, t]);

  return (
    <DreamerButton
      {...props}
      state={currentState}
      notifications={activeNotifications}
      notificationCount={notificationCount}
    />
  );
};

export default QueuedDreamerButton;
